// src/components/LoginForm.tsx
import React, { useState } from "react";
import { signInWithEmailAndPassword, browserLocalPersistence, browserSessionPersistence, setPersistence } from "firebase/auth";
import { auth } from "../firebase";
import "../styles/login.css";
import { logUserAction } from "../utils/logUtils";
import Footer from "../components/Footer";

interface LoginFormProps {
  onLoginSuccess: (user: any) => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await setPersistence(auth, remember ? browserLocalPersistence : browserSessionPersistence);
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      
      // Enregistrer l'action utilisateur
      const userEmail = userCredential.user.email;
      if (userEmail) {
        await logUserAction(
          userEmail,
          "Connexion",
          `Connexion réussie pour ${userEmail}`
        );
      }

      onLoginSuccess(userCredential.user);
    } catch (err: any) {
      console.error("Erreur de connexion :", err);
      switch (err.code) {
        case "auth/user-not-found":
          setError("Utilisateur inexistant.");
          break;
        case "auth/wrong-password":
          setError("Mot de passe incorrect.");
          break;
        case "auth/invalid-email":
          setError("Email invalide.");
          break;
        default:
          setError("Erreur de connexion.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-content-wrapper">
        <div className="login-box">
          <div className="welcome-header">
            <img 
              src="/RegExport_Conseil_SYMBOLE.png" 
              alt="RegExport Conseil" 
              className="welcome-icon"
            />
            <h1>Bienvenue <br/>sur REC-CRM</h1>
          </div>
          {error && <p className="error-text">{error}</p>}
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="email" className="input-label">Adresse Email :</label>
              <input
                id="email"
                type="email"
                placeholder="Entrer votre adresse email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="input-label">Mot de Passe :</label>
              <input
                id="password"
                type="password"
                placeholder="Entrer votre mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
              />
            </div>
            <div className="remember-row">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={remember}
                  onChange={() => setRemember(!remember)}
                  disabled={loading}
                />
                <span>Se souvenir de moi</span>
              </label>
            </div>
            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? "Connexion..." : "Se connecter"}
            </button>
          </form>
          
        </div>
      </div>
      <Footer />

    </div>
    
  );
};

export default LoginForm;
